import { Button } from "antd";
import React, { useMemo, useState } from "react";
import EditProjectSetUp from "../DailogBoxes/EditProjectSetUp";
import ProjectSetUp from "../DailogBoxes/ProjectSetUp";
import { formatDate } from "../../../utils/UtilService";
import SuccessDailogBox from "../../../components/Elements/DailogBox/SuccessDailogBox";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const ProjectStatus = ({ projectData, projectId, setProjectSetup, onSave }) => {
  const [openEditProjectSetUp, setOpenEditProjectSetUp] = useState(false);
  const [openProjectSetUp, setOpenProjectSetUp] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [projectSetupSuccess, setProjectSetUpSuccess] = useState(false);
  const header = useMemo(
    () => [
      { label: "TYPE OF LICENSE", key: "typeOfLicense" },
      { label: "TOTAL LICENSE", key: "totalLicense" },
      { label: "USED", key: "used" },
      { label: "REMAINING", key: "remaining" },
    ],
    []
  );

  const licenseTableSample = useMemo(() => {
    const license = projectData.license || {};
    const licenseTypes = [
      { key: "user", label: "USER" },
      // { key: "sub_admin", label: "SUB ADMIN" },
      // { key: "location_user", label: "LOCATION USER" },
      // { key: "location_admin", label: "LOCATION ADMIN" },
      { key: "local_supervisor", label: "LOCAL SUPERVISOR" },
      { key: "employee", label: "EMPLOYEE" },
      { key: "vendor", label: "VENDOR" },
    ];

    const tableData = licenseTypes.map(({ key, label }) => {
      const typeData = license[key] || {};
      return {
        typeOfLicense: label,
        totalLicense: typeData.total ?? "0",
        used: typeData.used ?? "0",
        remaining: typeData.unused ?? "0",
      };
    });

    return [{ key: 1, tableData }];
  }, [projectData.license]);

  const statusList = [
    "Project Created",
    "Project Setup Completed",
    "Form Submission in Progress",
    "Forms Submitted",
    "Report Requested",
    "Report Generated",
    "Audit Requested",
    "Audit in Progress",
    "Audit Completed",
  ];

  const currentStatus = projectData.status;

  return (
    <div className="mb-5">
      <div className="flex justify-between mx-2 my-auto ">
        <div className="flex gap-4 text-sm pl-4">
          <div>
            <p className="text-xs text-gray-500 font-medium">Project Name</p>
            <p className="font-semibold">{projectData.projectName}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 font-medium">Start Date</p>
            <p className="font-semibold">{formatDate(projectData.startDate)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 font-medium">End Date</p>
            <p className="font-semibold">{formatDate(projectData.endDate)}</p>
          </div>
        </div>
        <div className="flex gap-1 text-sm">
          <div>
            <Button
              type="primary"
              style={{
                background: "#06513D",
                height: "50px",
                borderRadius: "10px",
              }}
              className="text-[10px] font-normal mb-4 py-2 hover:!bg-[#387464]"
              // onClick={handleGenerateReport}
            >
              Login as a user
            </Button>
          </div>
          <div>
            <Button
              type="primary"
              style={{
                background: "#06513D",
                height: "50px",
                borderRadius: "10px",
              }}
              className="text-[10px] font-normal mb-4 py-2 hover:!bg-[#387464]"
              // onClick={handleGenerateReport}
            >
              Export all from data
            </Button>
          </div>
          <div>
            <Button
              type="primary"
              style={{
                background: "#06513D",
                height: "50px",
                borderRadius: "10px",
              }}
              className="text-[10px] font-normal mb-4 py-2 hover:!bg-[#387464]"
              // onClick={handleGenerateReport}
            >
              View Dashboard
            </Button>
          </div>
          <div>
            <Button
              type="primary"
              style={{
                background: "#06513D",
                height: "50px",
                borderRadius: "10px",
              }}
              className="text-[10px] font-normal mb-4 py-2 hover:!bg-[#387464]"
              onClick={() => {
                setOpenProjectSetUp(true);
              }}
            >
              {projectData.status === "Project Created"
                ? " Project Set-up "
                : "Edit Project Set-up"}
            </Button>
          </div>
          {/* <div>
            <Button
              type="primary"
              style={{
                background: "#06513D",
                height: "50px",
                borderRadius: "10px",
              }}
              className="text-[10px] font-normal mb-4 py-2"
              onClick={() => {
                setOpenEditProjectSetUp(true);
              }}
            >
             { projectData.status  === "Project Created" ? " Project Set-up ": "Edit Project Set-up"}
            </Button>
          </div> */}
        </div>
      </div>
      <div className="py-1 pl-4 pr-4">
        <hr />
      </div>

      <div className="flex justify-between mx-4 items-center ">
        <div>
          <table className="table-auto w-full text-[13px] border-collapse">
            <thead>
              <tr className="text-gray-600 font-semibold">
                {header.map((column) => (
                  <th
                    key={column.key}
                    className="px-4 py-2 text-center font-semibold"
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {licenseTableSample[0].tableData.map((row, index) => (
                <tr key={index} className="">
                  {header.map((column) => (
                    <td
                      key={column.key}
                      className={`px-4 py-4 text-[14px] font-[350] ${
                        column.key === 0 ? "text-left" : "text-center"
                      }`}
                    >
                      {typeof row[column.key] === "object" && row[column.key] !== null
                        ? row[column.key].total ?? row[column.key].issued ?? JSON.stringify(row[column.key])
                        : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex gap-10 text-sm font-medium">
          <p>PROJECT TYPE</p>
          <p>{projectData.projectType}</p>
          {/* <p className="pt-4">NUMBER OF USER LOGIN</p> */}
          {/* <p className="pt-4">% OF USER</p> */}

          <div>
            {/* <p className="pt-4">200/155</p> */}
            {/* <p className="pt-4">78%</p> */}
          </div>
        </div>
        <div className="pr-8">
          <p className="text-sm">PROJECT STATUS</p>
          <div className="relative ">
            <ul className="relative text-[12px] space-y-0">
              {statusList.map((status, idx) => {
                const isActive = status === currentStatus;
                const isCompleted =
                  statusList.indexOf(status) <
                  statusList.indexOf(currentStatus);
                const isLast = idx === statusList.length - 1;

                return (
                  <li key={idx} className="flex gap-2 relative">
                    {/* Dot + Line */}
                    <div className="flex flex-col items-center">
                      {/* Dot */}
                      <div
                        className={`w-2 h-2 rounded-full ${
                          isActive || isCompleted
                            ? "bg-[#38A28D]"
                            : "bg-gray-300"
                        }`}
                      ></div>

                      {/* Line below the dot */}
                      {!isLast && (
                        <div
                          className={`w-[2px] flex-1 ${
                            isCompleted ? "bg-[#38A28D]" : "bg-gray-300"
                          }`}
                          style={{ minHeight: "16px" }}
                        ></div>
                      )}
                    </div>

                    {/* Status text */}
                    <div>
                      <span
                        className={`${
                          isActive
                            ? "text-[#06513D] font-semibold"
                            : isCompleted
                            ? "text-gray-700"
                            : "text-gray-400"
                        }`}
                      >
                        {status}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      {/* not in use */}
      {openEditProjectSetUp && (
        <EditProjectSetUp
          open={openEditProjectSetUp}
          projectId={projectId}
          projectData={projectData}
          onCancel={() => {
            setOpenEditProjectSetUp(false);
          }}
        />
      )}

      {openProjectSetUp && (
        <ProjectSetUp
          open={openProjectSetUp}
          projectId={projectId}
          projectData={projectData}
          popupData={popupData}
          setPopupData={setPopupData}
          onCancel={() => {
            setOpenProjectSetUp(false);
          }}
          setProjectSetup={setProjectSetup}
        />
      )}

      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}

      {projectSetupSuccess && (
        <SuccessDailogBox
          onOpen={projectSetupSuccess}
          onClose={() => setProjectSetUpSuccess(false)}
          popuptype="success"
          successMessage={"Project License Setup/Edit Successfully"}
        />
      )}
    </div>
  );
};

export default ProjectStatus;
